import Typography from '@mui/material/Typography';
import { getAcisData, setupFilters, passesFilter } from '../js/dataAccessRoutines';
import ListhrlyTable from './ListhrlyTable';

// Hourly Lister Processing //

const setListhrlyResults = (results, setResult) => {
  if (results) {
    const code = (
      <ListhrlyTable 
          results={results}
          userParams={results.userParams}
          tabledata={results.tabledata}
          stnName={results.stnName}
      />
    );
    setResult(code)
  } else {
    setResult("")
  }
}

const processData = (res, userParams) => {
  const vars = userParams.variables;
  const stnName = res.meta.name + ", " + res.meta.state;
  const filters = setupFilters(userParams);
  const tabledata = []
  const wgust_column = vars.indexOf('wgust')

  res.data.forEach((results, i) => {
    if (passesFilter(results[0], filters)) {
      const rowdata = {}
      rowdata.index = i
      rowdata.date = results[0].slice(0,10)
      rowdata.hour = results[0].slice(11,13)
      vars.forEach((v, i) => {
        rowdata[v] = results[i + 1] !== "-0" ? results[i + 1] : "0"
        if (i === wgust_column && rowdata[v] === "M") {
          rowdata[v] = "-"
        }
      })      
      tabledata.push(rowdata)
    }
  })
  return {tabledata, stnName}
}

export function processListhrly(userParams, setResult, hourlyVx) {
    const vars = userParams.variables;
    const sid = userParams.sid;
    const network = sid.indexOf(" ") > 0 ? sid.split(" ")[1] : 'icao';
    const sdate = [userParams.fromDate.year(),userParams.fromDate.month()+1,userParams.fromDate.date(),1] || [2024,1,1,1];
    // end hour 24, which is hour 0 the next day
    const nextday = new Date(userParams.toDate);
    nextday.setDate(userParams.toDate.date() + 1)
    const edate = [nextday.getFullYear(),nextday.getMonth()+1,nextday.getDate(),0] || [2025,1,1,0];
    const elems = [];
    vars.forEach((v) => {
      elems.push({vX: hourlyVx[network][v], interval: [0,0,0,1], duration: 1})
    })

    const acisParams = {
        sid: sid,
        sDate: sdate,
        eDate: edate,
        elems: elems
    }
    getAcisData(acisParams)
    .then(res => {
      const results = processData(res, userParams);
      setListhrlyResults({userParams, ...results}, setResult)
    })
    .catch(error =>  { 
      console.log("Data retrieval error: " + error);  
      setResult((
        <Typography sx={{color: "red"}}>
          Error processing request - {error.acisStatus}
        </Typography>
      ))
    })
}